import { render, staticRenderFns } from "./ResearchVolcanoPlot.vue?vue&type=template&id=45b19f20"
import script from "./ResearchVolcanoPlot.vue?vue&type=script&lang=js"
export * from "./ResearchVolcanoPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchVolcanoPlot.vue?vue&type=style&index=0&id=45b19f20&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b19f20')) {
      api.createRecord('45b19f20', component.options)
    } else {
      api.reload('45b19f20', component.options)
    }
    module.hot.accept("./ResearchVolcanoPlot.vue?vue&type=template&id=45b19f20", function () {
      api.rerender('45b19f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchVolcanoPlot.vue"
export default component.exports